import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-238038c9"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "font-semibold text-xl text-gray-800 leading-tight" }, " 学校管理 ユーザ簡易登録画面 ", -1));
const _hoisted_2 = { class: "flex justify-center" };
const _hoisted_3 = { class: "max-w-7xl m-4" };
const _hoisted_4 = { class: "py-4 mb-4" };
const _hoisted_5 = ["href"];
const _hoisted_6 = {
    key: 0,
    class: "mt-2 text-red-500"
};
const _hoisted_7 = { class: "shadow-lg bg-white rounded-lg rounded-b-none p-6" };
const _hoisted_8 = { class: "flex mb-4" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "block font-medium text-gray-700",
    for: "isStudent"
}, " 学生として登録する ", -1));
const _hoisted_10 = {
    key: 0,
    class: "flex mb-4"
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "block font-medium text-gray-700",
    for: "isAddSchoolInfo"
}, " アカウント登録済みの場合、アカウントに所属学校情報を追加・上書きする ", -1));
const _hoisted_12 = {
    key: 1,
    class: "flex mb-4"
};
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "pt-2 mr-2 text-right",
    for: "school_name"
}, " 学校名： ", -1));
const _hoisted_14 = ["value"];
const _hoisted_15 = { class: "mb-4" };
const _hoisted_16 = {
    method: "post",
    enctype: "multipart/form-data"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
    key: 0,
    class: "my-4"
};
const _hoisted_19 = {
    key: 2,
    class: "mb-8"
};
const _hoisted_20 = ["disabled", "onClick"];
const _hoisted_21 = {
    key: 3,
    class: "mb-8"
};
const _hoisted_22 = ["disabled", "onClick"];
const _hoisted_23 = { class: "flex mb-4" };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "block font-medium text-gray-700",
    for: "isGrantExam"
}, " 模試を付与する ", -1));
const _hoisted_25 = { key: 0 };
const _hoisted_26 = ["value"];
const _hoisted_27 = { class: "flex items-center mb-10 justify-end px-4 py-3 bg-gray-50 text-right shadow rounded-b-lg" };
const _hoisted_28 = ["disabled"];
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mr-3 flex-1" }, null, -1));
const _hoisted_30 = { class: "m-4" };
const _hoisted_31 = { key: 0 };
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-500" }, [
    /*#__PURE__*/ _createTextVNode(" ※上記人数と以下のリスト内容に差異がある場合は、"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode(" ファイルフォーマットを見直してください"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode(" ※すでに学校が登録されているアカウントは赤文字で表示されます。")
], -1));
const _hoisted_33 = {
    key: 1,
    class: "ml-8 mb-6"
};
const _hoisted_34 = {
    key: 2,
    class: "ml-8 mb-4 grid grid-cols-12"
};
const _hoisted_35 = { class: "col-span-4 flex items-center" };
const _hoisted_36 = { class: "mx-auto py-3 px-2 col-span-4 block bg-red-600 hover:shadow-lg text-white rounded" };
const _hoisted_37 = /*#__PURE__*/ _createTextVNode(" ユーザID・パス入りデータ出力 ");
const _hoisted_38 = {
    key: 3,
    class: "ml-8 mb-4 grid grid-cols-12"
};
const _hoisted_39 = { class: "col-span-4 flex items-center" };
const _hoisted_40 = { class: "mx-auto py-3 px-2 col-span-4 block bg-red-600 hover:shadow-lg text-white rounded" };
const _hoisted_41 = /*#__PURE__*/ _createTextVNode(" CSVデータ出力 ");
const _hoisted_42 = {
    key: 4,
    class: "ml-8 mb-4 grid grid-cols-12"
};
const _hoisted_43 = { class: "col-span-4 flex items-center" };
const _hoisted_44 = { class: "mx-auto py-3 px-2 block col-span-4 bg-red-600 hover:shadow-lg text-white rounded" };
const _hoisted_45 = /*#__PURE__*/ _createTextVNode(" CSVデータ出力 ");
const _hoisted_46 = {
    key: 5,
    class: "ml-8 mb-4 grid grid-cols-12"
};
const _hoisted_47 = { class: "col-span-4 flex items-center" };
const _hoisted_48 = { class: "mx-auto py-3 px-2 block col-span-4 bg-red-600 hover:shadow-lg text-white rounded" };
const _hoisted_49 = /*#__PURE__*/ _createTextVNode(" CSVデータ出力 ");
const _hoisted_50 = {
    key: 6,
    class: "ml-8 mb-6 grid grid-cols-12"
};
const _hoisted_51 = { class: "col-span-4 flex items-center" };
const _hoisted_52 = { class: "mx-auto py-3 px-2 block col-span-4 bg-red-600 hover:shadow-lg text-white rounded" };
const _hoisted_53 = /*#__PURE__*/ _createTextVNode(" CSVデータ出力 ");
const _hoisted_54 = {
    key: 7,
    class: "py-4 flex flex-col items-center"
};
const _hoisted_55 = { class: "py-2 align-middle inline-block min-w-max" };
const _hoisted_56 = {
    class: "shadow overflow-x-hidden overflow-y-auto border-b border-gray-200 sm:rounded-lg",
    style: { "height": "600px" }
};
const _hoisted_57 = { class: "divide-y divide-gray-200" };
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", { class: "bg-gray-50" }, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
        }, " 氏名 "),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
        }, " 学籍番号 "),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
        }, " メールアドレス "),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
        }, " 学科 "),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
        }, " 学年 "),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider"
        }, " 重複学校 ")
    ])
], -1));
const _hoisted_59 = { class: "px-6 py-4 whitespace-nowrap" };
const _hoisted_60 = { class: "flex items-center" };
const _hoisted_61 = { class: "px-6 py-4 whitespace-nowrap" };
const _hoisted_62 = { class: "px-6 py-4 whitespace-nowrap" };
const _hoisted_63 = { class: "px-6 py-4 whitespace-nowrap" };
const _hoisted_64 = { class: "px-6 py-4 whitespace-nowrap" };
const _hoisted_65 = { class: "px-6 py-4 whitespace-nowrap" };
const _hoisted_66 = {
    key: 0,
    class: "loading"
};
import { ref, computed, reactive, } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import DownloadCsv from 'vue-json-csv';
import AppLayout from '@/Layouts/AppLayout.vue';
// @ts-ignore
import route from '@/types/Route';
export default /*#__PURE__*/ _defineComponent({
    props: {
        schools: {
            type: Object,
            default: () => ({}),
        },
        examinations: {
            type: Array,
            default: () => [],
        },
        selectedSchool: {
            type: Object,
            default: null,
        },
        isSelectedStudent: {
            type: Boolean,
            default: true,
        },
        isSelectedAddSchoolInfo: {
            type: Boolean,
            default: true,
        },
        isSelectedGrantExam: {
            type: Boolean,
            default: false,
        },
        selectedExamsId: {
            type: Array,
            default: () => [],
        },
        AddedIdAndPassUserData: {
            type: Object,
            default: () => ({}),
        },
        existEmailUsersData: {
            type: Object,
            default: () => ({}),
        },
        notReceivedEmailUsersData: {
            type: Object,
            default: () => ({}),
        },
        failedRegisterUsersData: {
            type: Object,
            default: () => ({}),
        },
        errorList: {
            type: Object,
            default: () => ({}),
        },
        AddedIdAndPassUserDataHeader: {
            type: Array,
            default: () => [],
        },
        usersDataHeader: {
            type: Array,
            default: () => [],
        },
        notReceivedEmailUsersDataHeader: {
            type: Array,
            default: () => [],
        },
        errorListHeader: {
            type: Array,
            default: () => [],
        },
        registeredUserCount: {
            type: Number,
            default: 0,
        },
        checkItems: {
            type: Array,
            default: () => [],
        },
        isProgressTask: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props) {
        const props = __props;
        const isProcessing = ref(false);
        const refCsvFile = ref();
        const csvFileNamePreview = ref();
        const hasCsvFile = computed(() => !!csvFileNamePreview.value);
        const isCheckedCsv = ref(false);
        const form = reactive(Inertia.form({
            selectedSchool: props.selectedSchool,
            isStudent: props.isSelectedStudent,
            isAddSchoolInfo: props.isSelectedAddSchoolInfo,
            isGrantExam: props.isSelectedGrantExam,
            selectedExamsId: props.selectedExamsId,
            csvFile: '',
            checkItems: [],
        }));
        const getAddedIdAndPassUserFileName = computed(() => `userData_${props.selectedSchool ? props.selectedSchool.name : 'generalUser'}.csv`);
        const existEmailUserFileName = computed(() => `existEmailUser_${props.selectedSchool ? props.selectedSchool.name : 'generalUser'}.csv`);
        const notReceivedEmailUserFileName = computed(() => `notReceivedEmailUser_${props.selectedSchool ? props.selectedSchool.name : 'generalUser'}.csv`);
        const failedRegisterUserFileName = computed(() => `failedRegisterUser_${props.selectedSchool ? props.selectedSchool.name : 'generalUser'}.csv`);
        const errorListFileName = computed(() => `errorListFileName_${props.selectedSchool ? props.selectedSchool.name : 'generalUser'}.csv`);
        const getAddedIdAndPassUserData = computed(() => {
            const csvData = [];
            props.AddedIdAndPassUserData.forEach((userData) => {
                csvData.push(userData);
            });
            return csvData;
        });
        const getExistEmailUsersData = computed(() => {
            const csvData = [];
            props.existEmailUsersData.forEach((userData) => {
                csvData.push(userData);
            });
            return csvData;
        });
        const getNotReceivedEmailUsersData = computed(() => {
            const csvData = [];
            props.notReceivedEmailUsersData.forEach((userData) => {
                csvData.push(userData);
            });
            return csvData;
        });
        const getFailedRegisterUsersData = computed(() => {
            const csvData = [];
            props.failedRegisterUsersData.forEach((userData) => {
                csvData.push(userData);
            });
            return csvData;
        });
        const getErrorList = computed(() => {
            const csvData = [];
            props.errorList.forEach((userData) => {
                csvData.push(userData);
            });
            return csvData;
        });
        const messages = reactive({
            schoolInfo: {
                errors: [''],
            },
        });
        const onFileChanged = (e) => {
            csvFileNamePreview.value = e.target.files[0].name;
            form.csvFile = refCsvFile.value?.files?.[0];
            isProcessing.value = false;
        };
        const openFileView = (event) => {
            refCsvFile?.value?.click();
        };
        const onClickedCheckBox = (e) => e.stopPropagation();
        // is_duplicateがtrueがある場合ボタンを無効化する
        const hasDuplicates = computed(() => {
            return props.checkItems.some(item => item.is_duplicate === true);
        });
        const onSubmitted = async () => {
            isProcessing.value = true;
            messages.schoolInfo.errors = [];
            if (!form.selectedSchool && form.isStudent) {
                messages.schoolInfo.errors.push('学校名を選択してください。');
                isProcessing.value = false;
                return;
            }
            form.checkItems = props.checkItems;
            form.post(route('usersRegistration.create'), {
                onSuccess: () => {
                    isProcessing.value = false;
                },
            });
        };
        const onCheck = () => {
            isProcessing.value = true;
            messages.schoolInfo.errors = [];
            form.post(route('usersRegistration.check-csv'), {
                onSuccess: () => {
                    isProcessing.value = false;
                    isCheckedCsv.value = true;
                },
            });
        };
        const onReturnClicked = () => {
            Inertia.get(route('school'));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AppLayout, { title: "QuestionShow" }, {
                header: _withCtx(() => [
                    _hoisted_1
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("a", {
                                    class: "py-3 px-6 bg-blue-600 hover:shadow-lg text-white rounded",
                                    href: _unref(route)('usersRegistration.task')
                                }, "登録タスク一覧", 8, _hoisted_5),
                                (__props.isProgressTask)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, " ※進行中のタスクがあります。 "))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "isStudent",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).isStudent) = $event)),
                                        type: "checkbox",
                                        class: "h-5 w-5 mr-3 rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50",
                                        autofocus: ""
                                    }, null, 512), [
                                        [_vModelCheckbox, _unref(form).isStudent]
                                    ]),
                                    _hoisted_9
                                ]),
                                (_unref(form).isStudent)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "isAddSchoolInfo",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).isAddSchoolInfo) = $event)),
                                            type: "checkbox",
                                            class: "h-5 w-5 mr-3 rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50",
                                            autofocus: ""
                                        }, null, 512), [
                                            [_vModelCheckbox, _unref(form).isAddSchoolInfo]
                                        ]),
                                        _hoisted_11
                                    ]))
                                    : _createCommentVNode("", true),
                                (_unref(form).isStudent)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _hoisted_13,
                                        _withDirectives(_createElementVNode("select", {
                                            id: "school_name",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).selectedSchool) = $event)),
                                            class: "border border-gray-300 outline-none rounded-md bg-white placeholder-gray-400 text-gray-500 focus:outline-none"
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.schools, (school) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: school.id,
                                                    value: school
                                                }, _toDisplayString(school.name), 9, _hoisted_14));
                                            }), 128))
                                        ], 512), [
                                            [_vModelSelect, _unref(form).selectedSchool]
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("form", _hoisted_16, [
                                        _createElementVNode("input", {
                                            ref: (_value, _refs) => {
                                                _refs['refCsvFile'] = _value;
                                                refCsvFile.value = _value;
                                            },
                                            type: "file",
                                            accept: ".csv",
                                            class: "hidden",
                                            onChange: onFileChanged
                                        }, null, 544),
                                        _createElementVNode("button", {
                                            class: "px-4 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg",
                                            name: "image_url_commentary",
                                            onClick: _withModifiers(openFileView, ["prevent"])
                                        }, " ファイル選択 ", 8, _hoisted_17)
                                    ]),
                                    (_unref(hasCsvFile))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(csvFileNamePreview.value), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                (csvFileNamePreview.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        (_unref(messages).schoolInfo.errors)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(messages).schoolInfo.errors, (error, index) => {
                                                return (_openBlock(), _createElementBlock("p", {
                                                    key: index,
                                                    class: "text-red-500 text-sm"
                                                }, _toDisplayString(error), 1));
                                            }), 128))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("button", {
                                            disabled: isProcessing.value,
                                            class: "py-2 px-6 bg-blue-600 hover:shadow-lg text-white rounded disabled:bg-gray-400 disabled:cursor-not-allowed",
                                            onClick: _withModifiers(onCheck, ["prevent"])
                                        }, " CSVファイル事前チェック ", 8, _hoisted_20)
                                    ]))
                                    : _createCommentVNode("", true),
                                (isCheckedCsv.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        (_unref(messages).schoolInfo.errors)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(messages).schoolInfo.errors, (error, index) => {
                                                return (_openBlock(), _createElementBlock("p", {
                                                    key: index,
                                                    class: "text-red-500 text-sm"
                                                }, _toDisplayString(error), 1));
                                            }), 128))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("button", {
                                            disabled: !(__props.checkItems && __props.checkItems.length) || (!_unref(form).selectedSchool && _unref(form).isStudent) || isProcessing.value || _unref(hasDuplicates),
                                            class: "py-2 px-6 bg-green-500 hover:shadow-lg text-white rounded disabled:bg-gray-400 disabled:cursor-not-allowed",
                                            onClick: _withModifiers(onSubmitted, ["prevent"])
                                        }, " 登録処理実行 ", 8, _hoisted_22)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_23, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "isGrantExam",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).isGrantExam) = $event)),
                                            type: "checkbox",
                                            value: "",
                                            class: "h-5 w-5 mr-3 rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50",
                                            autofocus: ""
                                        }, null, 512), [
                                            [_vModelCheckbox, _unref(form).isGrantExam]
                                        ]),
                                        _hoisted_24
                                    ]),
                                    (_unref(form).isGrantExam)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.examinations, (examination, key) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: key,
                                                    class: "mt-2 px-2"
                                                }, [
                                                    _createElementVNode("label", null, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(form).selectedExamsId) = $event)),
                                                            value: examination.id,
                                                            type: "checkbox",
                                                            class: "bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-5 w-5 rounded focus:outline-none",
                                                            onClick: onClickedCheckBox
                                                        }, null, 8, _hoisted_26), [
                                                            [_vModelCheckbox, _unref(form).selectedExamsId]
                                                        ]),
                                                        _createTextVNode(" " + _toDisplayString(examination.title), 1)
                                                    ])
                                                ]));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass([{ 'opacity-25': isProcessing.value }, "px-8 py-2 rounded border border-blue-600 text-blue-600 max-w-max shadow-sm hover:shadow-lg"]),
                                    disabled: isProcessing.value,
                                    onClick: onReturnClicked
                                }, " 戻る ", 10, _hoisted_28),
                                _hoisted_29
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                            (__props.checkItems.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createTextVNode(" 事前読み込み人数：" + _toDisplayString(__props.checkItems.length) + " ", 1),
                                    _hoisted_32
                                ]))
                                : _createCommentVNode("", true),
                            (__props.registeredUserCount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, " リスト記載人数： " + _toDisplayString(props.registeredUserCount +
                                    props.existEmailUsersData.length +
                                    props.failedRegisterUsersData.length) + "名 ", 1))
                                : _createCommentVNode("", true),
                            (__props.registeredUserCount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, " 登録したユーザ： " + _toDisplayString(__props.registeredUserCount) + "名 ", 1),
                                    _createElementVNode("button", _hoisted_36, [
                                        _createVNode(_unref(DownloadCsv), {
                                            data: _unref(getAddedIdAndPassUserData),
                                            labels: __props.AddedIdAndPassUserDataHeader,
                                            name: _unref(getAddedIdAndPassUserFileName)
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_37
                                            ]),
                                            _: 1
                                        }, 8, ["data", "labels", "name"])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (__props.existEmailUsersData.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createElementVNode("div", _hoisted_39, " 入力されたメールアドレスが既に登録済みのユーザ： " + _toDisplayString(__props.existEmailUsersData.length) + "名 ", 1),
                                    _createElementVNode("button", _hoisted_40, [
                                        _createVNode(_unref(DownloadCsv), {
                                            data: _unref(getExistEmailUsersData),
                                            labels: __props.usersDataHeader,
                                            name: _unref(existEmailUserFileName)
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_41
                                            ]),
                                            _: 1
                                        }, 8, ["data", "labels", "name"])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (__props.notReceivedEmailUsersData.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, " メールが送信失敗したユーザ " + _toDisplayString(__props.notReceivedEmailUsersData.length) + "名 ", 1),
                                    _createElementVNode("button", _hoisted_44, [
                                        _createVNode(_unref(DownloadCsv), {
                                            data: _unref(getNotReceivedEmailUsersData),
                                            labels: __props.notReceivedEmailUsersDataHeader,
                                            name: _unref(notReceivedEmailUserFileName)
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_45
                                            ]),
                                            _: 1
                                        }, 8, ["data", "labels", "name"])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (__props.failedRegisterUsersData.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, " 登録処理が失敗したユーザ： " + _toDisplayString(__props.failedRegisterUsersData.length) + "名 ", 1),
                                    _createElementVNode("button", _hoisted_48, [
                                        _createVNode(_unref(DownloadCsv), {
                                            data: _unref(getFailedRegisterUsersData),
                                            labels: __props.usersDataHeader,
                                            name: _unref(failedRegisterUserFileName)
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_49
                                            ]),
                                            _: 1
                                        }, 8, ["data", "labels", "name"])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (__props.errorList.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, " 登録処理が失敗したユーザのエラーリスト： " + _toDisplayString(__props.errorList.length) + "名 ", 1),
                                    _createElementVNode("button", _hoisted_52, [
                                        _createVNode(_unref(DownloadCsv), {
                                            data: _unref(getErrorList),
                                            labels: __props.errorListHeader,
                                            name: _unref(errorListFileName)
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_53
                                            ]),
                                            _: 1
                                        }, 8, ["data", "labels", "name"])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (__props.checkItems.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                        _createElementVNode("div", _hoisted_56, [
                                            _createElementVNode("table", _hoisted_57, [
                                                _hoisted_58,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.checkItems, (item, i) => {
                                                    return (_openBlock(), _createElementBlock("tbody", {
                                                        key: i,
                                                        class: "bg-white divide-y divide-gray-200"
                                                    }, [
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("td", _hoisted_59, [
                                                                _createElementVNode("div", _hoisted_60, [
                                                                    _createElementVNode("div", {
                                                                        class: _normalizeClass(item.is_duplicate ? 'text-red-500' : 'text-gray-900')
                                                                    }, _toDisplayString(Object.values(item)[0]), 3)
                                                                ])
                                                            ]),
                                                            _createElementVNode("td", _hoisted_61, [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(item.is_duplicate ? 'text-red-500' : 'text-gray-900')
                                                                }, _toDisplayString(item.student_id), 3)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_62, [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(item.is_duplicate ? 'text-red-500' : 'text-gray-900')
                                                                }, _toDisplayString(item.email), 3)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_63, [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(["px-2 inline-flex leading-5 rounded-full", item.is_duplicate ? 'text-red-500' : 'text-gray-900'])
                                                                }, _toDisplayString(item.department), 3)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_64, [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(["px-2 inline-flex leading-5 rounded-full", item.is_duplicate ? 'text-red-500' : 'text-gray-900'])
                                                                }, _toDisplayString(item.grade), 3)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_65, [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(["px-2 inline-flex leading-5 rounded-full", item.is_duplicate ? 'text-red-500' : 'text-gray-900'])
                                                                }, _toDisplayString(item.duplicate_school ? item.duplicate_school : ''), 3)
                                                            ])
                                                        ])
                                                    ]));
                                                }), 128))
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    (isProcessing.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["spinner", { 'loaded': !isProcessing.value }])
                            }, null, 2)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
